import React from "react";
import "@/App.css";
import { HelmetProvider } from 'react-helmet-async';
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import SocialProof from "@/components/sections/SocialProof";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import ExpertDomains from "@/components/sections/ExpertDomains";
import HowItWorks from "@/components/sections/HowItWorks";
import WhyChoose from "@/components/sections/WhyChoose";
import Pricing from "@/components/sections/Pricing";
import Testimonials from "@/components/sections/Testimonials";
import CTA from "@/components/sections/CTA";
import Footer from "@/components/sections/Footer";
import ExpertsPage from "@/components/sections/expertspage";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import MegaEvent from "@/components/sections/MegaEvent";
import VerifyTicket from "@/components/sections/VerifyTicket";
import Awards from "@/components/sections/Awards";

// 👇 Replace with your actual WhatsApp group invite link
const WHATSAPP_GROUP_LINK = "https://chat.whatsapp.com/YOUR_GROUP_INVITE_CODE";

function WhatsAppFloatingButton() {
  return (
    <a
      href="https://chat.whatsapp.com/LxXQ83O3fe92mLDKmN6N0S"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "28px",
        right: "28px",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: "10px",
        backgroundColor: "#25D366",
        color: "#fff",
        borderRadius: "50px",
        padding: "12px 18px 12px 14px",
        boxShadow: "0 4px 16px rgba(37,211,102,0.35)",
        textDecoration: "none",
        fontFamily: "sans-serif",
        fontSize: "14px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(37,211,102,0.5)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(37,211,102,0.35)";
      }}
    >
      {/* WhatsApp SVG icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="26"
        height="26"
        fill="#fff"
      >
        <path d="M16 2C8.268 2 2 8.268 2 16c0 2.49.647 4.829 1.778 6.865L2 30l7.335-1.922A13.94 13.94 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.6a11.54 11.54 0 0 1-5.89-1.614l-.422-.25-4.353 1.141 1.162-4.24-.276-.437A11.6 11.6 0 0 1 4.4 16C4.4 9.593 9.593 4.4 16 4.4S27.6 9.593 27.6 16 22.407 27.6 16 27.6zm6.39-8.687c-.35-.175-2.07-1.02-2.39-1.137-.32-.117-.553-.175-.786.175-.233.35-.902 1.137-1.106 1.37-.203.233-.407.262-.757.087-.35-.175-1.478-.545-2.815-1.737-1.04-.928-1.742-2.073-1.946-2.423-.203-.35-.022-.539.153-.713.157-.157.35-.408.525-.612.175-.204.233-.35.35-.583.117-.233.058-.437-.029-.612-.087-.175-.786-1.896-1.077-2.596-.283-.682-.57-.589-.786-.6l-.67-.011c-.233 0-.612.087-.932.437-.32.35-1.223 1.195-1.223 2.915s1.252 3.381 1.427 3.615c.175.233 2.464 3.762 5.972 5.277.835.36 1.486.575 1.994.736.838.266 1.601.229 2.203.139.672-.1 2.07-.847 2.362-1.664.291-.817.291-1.518.203-1.664-.087-.146-.32-.233-.67-.408z" />
      </svg>
      Join our WhatsApp Community
      {/* Red notification dot */}
      <span
        style={{
          position: "absolute",
          top: "-4px",
          right: "-4px",
          width: "12px",
          height: "12px",
          backgroundColor: "#e53e3e",
          borderRadius: "50%",
          border: "2px solid #fff",
        }}
      />
    </a>
  );
}

function HomePage() {
  return (
    <div className="min-h-screen bg-ibh-bg text-slate-900 antialiased">
      <Navbar />
      <main>
        <Hero />
        <SocialProof />
        <About />
        <Services />
        <ExpertDomains />
        <HowItWorks />
        <WhyChoose />
        <Pricing />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

function ConditionalWhatsApp() {
  const location = useLocation();
  if (location.pathname !== "/") return null;
  return <WhatsAppFloatingButton />;
}

function App() {
  return (
  <HelmetProvider>
    <BrowserRouter>
      {/* ConditionalWhatsApp hides the button on /mega-event */}
      <ConditionalWhatsApp />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/experts" element={<ExpertsPage />} />
        <Route path="/mega-event" element={<MegaEvent />} />
        {/* <Route path="/awards" element={<Awards />} /> */}
        <Route path="/freedom-conclave" element={<MegaEvent />} />
<Route path="/freedom-conclave/register" element={<MegaEvent />} />
<Route path="/freedom-conclave/register-event" element={<MegaEvent />} />
<Route path="/freedom-conclave/register-event/details" element={<MegaEvent />} />
<Route path="/freedom-conclave/register-pitching" element={<MegaEvent />} />
<Route path="/freedom-conclave/register-pitching/details" element={<MegaEvent />} />
<Route path="/freedom-conclave/register-pitching-audience" element={<MegaEvent />} />
<Route path="/freedom-conclave/register-pitching-audience/details" element={<MegaEvent />} />
        <Route path="/verify" element={<VerifyTicket />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
    </BrowserRouter>
  </HelmetProvider>
  );
}

export default App;